module.exports = __webpack_public_path__ + "static/media/Bedroom7-1.7be18dfe.jpg";